import { render } from "./prime-tabview.vue?vue&type=template&id=01b7f437&scoped=true"
import script from "./prime-tabview.vue?vue&type=script&lang=js"
export * from "./prime-tabview.vue?vue&type=script&lang=js"

import "./prime-tabview.vue?vue&type=style&index=0&id=01b7f437&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b7f437"]])

export default __exports__